import React from "react";

import { tw } from "~/utils";

type FormSectionProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
  required?: boolean;
};

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  children,
  className,
  required = false,
}) => {
  return (
    <section className={tw("space-y-2 font-sans", className)}>
      <h2 className="text-midnight-indigo text-sm font-medium">
        {title}
        {required && <span className="ml-1 text-red-500">*</span>}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
};
